import { useState, React, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
// import { signInWithEmailAndPassword } from "firebase/auth";
// import { auth } from "../../firebase";
import { Image, LoginContainer, LoginForm } from "./LoginStyles";
import farmer from "../../Assets/farmer.webp";
import { useNavigate, Link } from "react-router-dom";
import { useQuery } from "react-query";
import axios from "axios";

// fetch login data from backend
const fetchLogin = async (email, password) => {
  return axios.post(
    "https://ancient-caverns-61891.herokuapp.com/api/v1/users/login",
    {
      email,
      password,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

const LoginPage = () => {
  const navigate = useNavigate();
  const value = useContext(AuthContext);
  console.log("log", value);
  const { currentUser, setUser } = value;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { data } = await fetchLogin(email, password);
    console.log(data);

    if (data.status === "success") {
      setUser({ currentUser: data.token });
      navigate("/dashboard");
    }

    console.log("currentUser", currentUser);
  };

  return (
    <LoginContainer>
      <LoginForm
        onSubmit={(e) => {
          handleSubmit(e);
        }}
      >
        <h1>
          Welcome to <span>FarmHub</span>
        </h1>
        <label>Email</label>
        <input
          type="name"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <label>Password</label>
        <input
          type="password"
          placeholder="Enter your password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button onClick={handleSubmit}>Login</button>
        {/* {
          // if error is true, display error message
          error && <span>Something went wrong!</span>
        } */}
        <div>
          Don't have an account?{" "}
          <Link to="/signup">
            <span>Sign up here</span>
          </Link>
        </div>
      </LoginForm>
      <Image></Image>
    </LoginContainer>
  );
};

export default LoginPage;
